var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-img',{attrs:{"src":("data:image/jpeg;base64," + _vm.imagen),"height":"500px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }